var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emat-order-action"},[_c('green-check-svg',{staticClass:"icon"}),_c('span',{staticClass:"label"},[_vm._v(" Levertijd "),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.label))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }